import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./auth";
import { AppShell } from "./Shell";
import { AuthPage, JoinPage } from "./pages/AuthPage";
import { CardPage } from "./pages/CardPage";
import { ChangelogPage } from "./pages/ChangelogPage";
import { LegalPage } from "./pages/LegalPage";
import { LoopsPage } from "./pages/LoopsPage";
import { LoopDetailPage } from "./pages/LoopDetailPage";
import { MarketingPage } from "./pages/MarketingPage";
import { AppNotFound, NotFoundPage } from "./pages/NotFoundPage";
import { StartPage } from "./pages/StartPage";
import { ClaimPage } from "./pages/ClaimPage";
import { OverviewPage } from "./pages/OverviewPage";
import { OAuthConsentPage } from "./pages/OAuthConsentPage";
import { OnboardingPage } from "./pages/OnboardingPage";
import { PeoplePage } from "./pages/PeoplePage";
import { SettingsPage } from "./pages/SettingsPage";

function ProtectedApp() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="boot"><div className="boot__loop" /><span>Finding the loop…</span></div>;
  if (!user) return <Navigate to="/signin" replace state={{ from: location.pathname }} />;
  return <AppShell />;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<MarketingPage />} />
      <Route path="/start" element={<StartPage />} />
      <Route path="/claim" element={<ClaimPage />} />
      <Route path="/claim/signup" element={<ClaimAuthPage mode="signup" />} />
      <Route path="/claim/signin" element={<ClaimAuthPage mode="signin" />} />
      <Route path="/signin" element={<AuthPage mode="signin" />} />
      <Route path="/signup" element={<AuthPage mode="signup" />} />
      <Route path="/join/:token" element={<JoinPage />} />
      <Route path="/c/:token" element={<CardPage />} />
      <Route path="/privacy" element={<LegalPage slug="privacy" />} />
      <Route path="/terms" element={<LegalPage slug="terms" />} />
      <Route path="/changelog" element={<ChangelogPage />} />
      <Route path="/oauth/consent" element={<OAuthConsentPage />} />
      <Route path="/app" element={<ProtectedApp />}>
        <Route index element={<OverviewPage />} />
        <Route path="onboarding" element={<OnboardingPage />} />
        <Route path="loops" element={<LoopsPage />} />
        <Route path="loops/:loopId" element={<LoopDetailPage />} />
        <Route path="people" element={<PeoplePage />} />
        <Route path="connect" element={<Navigate to="/app/settings#keys" replace />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<AppNotFound />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

function ClaimAuthPage({ mode }: { mode: "signin" | "signup" }) {
  const token = window.location.hash.replace(/^#/u, "");
  return <AuthPage mode={mode} claimToken={token} />;
}
